

























































































































































import { computed, ComputedRef, defineComponent, ref, PropType, toRefs } from '@vue/composition-api';
import {
  FileUploadStatus,
  MaterialType,
  FIX_PROBLEM_TIPS_LIST,
  VideoMaterial,
  AdgroupFormData,
  FullNormalFormData,
} from '@tt4b/ttam-enums';
import { useVideoUploader } from '@tt4b/ttam-hooks';
import { uploadTableFormatVerifyMsg } from '@tt4b/ttam-utils';
import CommonVideoSvg from '@tt4b/ttam-assets/src/images/creative/common-video.svg';
import CommonImageSvg from '@tt4b/ttam-assets/src/images/creative/common-image.svg';

import { i18n } from './../../../../i18n';

export default defineComponent({
  name: 'FilesProgressTable',
  props: {
    files: { type: Array, default: () => [] },
    fileType: { type: String, default: () => MaterialType.Video },
    inventoryCheck: { type: Boolean, default: true },
    aadvid: { type: String, default: '' },
    isAco: { type: Boolean, default: false },
    isSpc: { type: Boolean, default: false },
    adgroupData: { type: Object as PropType<AdgroupFormData>, default: () => ({}) },
    creativeData: { type: Object as PropType<FullNormalFormData>, default: () => ({}) },
  },

  setup(props, ctx) {
    const { aadvid, isAco, isSpc, adgroupData, creativeData } = toRefs(props);

    const files = computed(() => props.files) as ComputedRef<VideoMaterial[]>;
    const hasAfterVerify = computed(() => files.value.some(file => file.verifyMode));

    const uploadStatusLabelMap = ref({
      [FileUploadStatus.Cutting]: i18n.t('upload_optimizing'),
      [FileUploadStatus.Uploading]: i18n.t('upload_uploading'),
    });

    async function onRetry(file) {
      if (props.fileType === MaterialType.Image) {
        ctx.emit('retry', file);
        return;
      }

      const { start } = await useVideoUploader({
        isAco,
        isSpc,
        userId: aadvid.value,
        adgroupFormData: adgroupData,
        creativeFormData: creativeData,
        /** 需要上传的文件列表 */
        fileArr: [file],
        /** 是否需要预校验 */
        isNeedPreCheckBeforeUpload: true,
        /** 上传过程中各种事件 */
        events: {
          // onProcess?: (arg0: UploaderResponse, arg1) => unknown;
          // onError?: (arg0: UploaderResponse, arg1) => unknown;
          // onSuccess?: (arg0, arg1) => unknown;
          // onStatusChange?: (arg0, arg1) => unknown;
          // onValidateComplete?: (arg: any) => unknown;
          // onCut?: () => unknown;
        },
      });

      start();
    }

    function onAbort(file) {
      ctx.emit('cancel', file);
    }

    const codeMapText = (code, type) => {
      const Tips = FIX_PROBLEM_TIPS_LIST().filter(item => item.key === code);

      return Tips[0][type];
    };

    const { formatMsg, formatSize } = uploadTableFormatVerifyMsg();

    return {
      hasAfterVerify,
      uploadStatusLabelMap,
      fileUploadStatus: FileUploadStatus,
      CommonVideoSvg,
      CommonImageSvg,

      formatSize,
      onRetry,
      onAbort,
      codeMapText,
      formatMsg,
    };
  },
});
